import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateTextPipe } from '@app/providers/translate-text';

@NgModule({
  declarations: [
    TranslateTextPipe
  ],
  exports: [
    TranslateTextPipe
  ],
  imports: [
    CommonModule
  ],
})
export class TranslateModule { }
